import axios from '@/axiosInterceptor';

const state = () => ({});

// getters
const getters = {};

// actions
const actions = {
  async getAutocomplete(_, term) {
    try {
      let res = await axios.get(
        process.env.API_MONITOR + '/api/v1/areas/autocomplete?term=' + term
      );
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getZipCodes(_, term, { limit = 10 } = {}) {
    try {
      const query = {
        'q[is_type_eq]': 'five_zip',
        'q[code_start]': term,
        per_page: limit,
        'q[s]': 'name asc',
      };
      let res = await axios.get(process.env.API_MONITOR + '/api/v1/areas/', {
        params: query,
      });
      return res.data;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getCountries(_, { countries = ['US', 'CA', 'MX'] } = {}) {
    try {
      const params = {
        'q[is_type_in]': 'country',
        'q[country_in]': countries,
      };
      const res = await axios.get(process.env.API_MONITOR + `/api/v1/areas`, {
        params,
      });
      return res;
    } catch (e) {
      if (
        axios.isAxiosError(e) &&
        e.response &&
        [403, 422].includes(e.response.status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
